import {http, httpFile} from './http_service';
export function loadSlider(){
    return http().get('/slider');
}